<template>
    <form @submit.prevent="save" class="add_house modal">
        <div class="head">Добавление адреса</div>
        <div class="input">
            <input @input="search" v-model="address" type="text" class="address">
            <div class="autocomplete">
                <div @click="this.address=item.name; this.fiasID=item.id; this.autocomplete=[]"
                     v-for="(item, i) in autocomplete" :key="i" class="item">{{ item.name }}
                </div>
            </div>
        </div>
        <div class="buttons">
            <button>Далее</button>
            <div class="cancel" @click="$store.commit('changeShowModal', 'AddHouse')">
                <img src="@/assets/img/left_arrow.svg" alt="">
                <div class="text">Назад</div>
            </div>
        </div>


        <div @click="$store.commit('changeShowModal', 'AddHouse')" class="close">
            <img src="@/assets/img/close.svg" alt="">
        </div>
    </form>
</template>

<script>
export default {
    data() {
        return {
            address: "",
            fiasID: null,
            autocomplete: []
        }
    },
    methods: {
        async search() {
            this.fiasID = null
            let r = await this.$store.dispatch("baseRequest", {
                method: "POST",
                headers: {
                    "Authorization": "Token 06a40b71d62bef72bb25fe98799d8c875f23f63f",
                    "Content-Type": "application/json"
                },
                url: "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address",
                data: {query: this.address}
            })
            this.autocomplete = []
            if (r.status == 200) {
                for (let i = 0; i < 5 && i < r.response.suggestions.length; i++) {
                    this.autocomplete.push({
                        id: r.response.suggestions[i].data.fias_id,
                        name: r.response.suggestions[i].value
                    })
                }
            }
        },
        async save() {
            let r = await this.$store.dispatch("request", {
                path: "/adm/buildings",
                method: "POST",
                sendData: {
                    "fias_id": this.fiasID
                }
            })
            if (r.status == 200) {
                this.$store.commit("changeShowModal", "AddHouse")
                this.$store.dispatch("loadData")
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.add_house {
    .input {
        position: relative;

        input {
            width: 500px;
        }

        .autocomplete {
            position: absolute;
            left: 0;
            top: 100%;

            .item {
                border: 1px solid black;
                background: #FFFFFF;
                cursor: pointer;
            }
        }
    }
}
</style>